const initialState = {
  isModalVisible: false,
};

const adminModalReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SHOW_ADD_ADMIN_MODAL":
      return { ...state, isModalVisible: true };

    case "HIDE_ADD_ADMIN_MODAL":
      return { ...state, isModalVisible: false };

    default:
      return state;
  }
};

export default adminModalReducer;
